import { extendTailwindMerge, type ClassNameValue } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["error"],
    },
    classGroups: {
      "font-size": [
        "body-sm",
        "body-md",
        "body-lg",
        "body-xl",
        "title-sm",
        "title-md",
        "title-lg",
        "title-xl",
        "headline-sm",
        "headline-md",
        "headline-lg",
        "headline-xl",
      ],
    },
  },
});

export function cn(...inputs: ClassNameValue[]) {
  return twMerge(inputs);
}
